/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {Content} from '../common/content';
import {Communication} from '../services/communication';
import {Information} from '../common/information';
import {CommandBar} from '../common/commandbar';
import App from '../App';
import {Settings} from '../services/settings';

interface StatusState {
  isLoading: boolean;
  item: Record<string, unknown> | null;
}

export class Status extends React.Component<{}, StatusState> {
  readonly #map = {};

  constructor(props: {}, state: StatusState) {
    super(props, state);
    this.state = {isLoading: true, item: null};
  }

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    this.#reloadData(true);
  }

  #reloadData(skipLoadingUpdate?: true): void {
    if (skipLoadingUpdate === undefined) this.setState({isLoading: true});
    Communication.fetch('healthcheck', 'GET', 'json+object', undefined, {uptime: true}).then(
      (value) => {
        if (value.status === 'ok' && value.data !== null)
          this.setState({isLoading: false, item: value.data as Record<string, unknown>});
        else if (value.status === 'ok') App.toast('warn', 'Status', undefined, `Data of 'healthcheck' is invalid`);
        else
          App.toast(
            'error',
            'Status',
            undefined,
            `Loading of 'healthcheck' failed: ${
              ('error' in value && value.error.message) ||
              `[Code: ${value.code}] ${('data' in value && value.data) || 'Unknown'}`
            }`,
          );
      },
      (err) => {
        App.toast(
          'error',
          'Status',
          undefined,
          `Loading of 'healthcheck' failed: ${(err instanceof Error && err.message) || err}`,
        );
      },
    );
  }

  override render() {
    return (
      <Content
        section={`${Settings.application.NAME.SUITE} ${Settings.application.NAME.SERVICE} status`}
        isLoading={this.state.isLoading}
      >
        <CommandBar reloadCommand={() => this.#reloadData()}></CommandBar>
        <Information
          item={this.state.item}
          map={this.#map}
        />
      </Content>
    );
  }
}
